import {
  Spacer,
  StyledCancelButton,
  StyledDialogActions,
  StyledResetButton,
  StyledSaveButton
} from './BrandsOrderDialogActions.styles';
import { BrandOrderDialogActionsProps } from './BrandsOrderDialogActions.types';

export const BrandOrderDialogActions = ({
  isMobile,
  loading,
  onClose,
  onReset,
  onSave
}: BrandOrderDialogActionsProps) => {
  return (
    <StyledDialogActions isMobile={isMobile}>
      <StyledResetButton isMobile={isMobile} onClick={onReset} disabled={loading} color="warning">
        Скинути налаштування
      </StyledResetButton>

      {!isMobile && <Spacer />}

      <StyledCancelButton isMobile={isMobile} onClick={onClose} disabled={loading}>
        Скасувати
      </StyledCancelButton>

      <StyledSaveButton isMobile={isMobile} onClick={onSave} variant="contained" disabled={loading}>
        {loading ? 'Збереження...' : 'Зберегти'}
      </StyledSaveButton>
    </StyledDialogActions>
  );
};
